// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button {\n  outline: none !important; }\n\n.AdvancedSearch_filter_bar__1_edG {\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #ebebeb;\n  top: 50px !important; }\n  @media (max-width: 767px) {\n    .AdvancedSearch_filter_bar__1_edG {\n      top: 76px !important; } }\n\n.AdvancedSearch_detail_container__1SWkt {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 9999; }\n  @media (min-width: 768px) {\n    .AdvancedSearch_detail_container__1SWkt {\n      display: none; } }\n", ""]);
// Exports
exports.locals = {
	"filter_bar": "AdvancedSearch_filter_bar__1_edG",
	"detail_container": "AdvancedSearch_detail_container__1SWkt"
};
module.exports = exports;
